import * as Sentry from '@sentry/vue';
import axios from 'axios';
import bowser from 'bowser';
import DownloadsDialog from 'components/DownloadsDialog/DownloadsDialog';
import exports from 'components/Exports/Exports';
import reports from 'components/Reports/Reports';
import Url from 'domurl';
import Hammer from 'hammerjs';
import { trackDashboardEvents } from 'js/eventsTracking';
import httpClient from 'js/httpClient';
import assetSelectorMixin from 'js/mixins/assetSelectorMixin';
import viewsInfoMixin from 'js/mixins/viewsInfoMixin';
import vuetify from 'js/vuetify';
import {
    concat,
    filter,
    find,
    findIndex,
    findKey,
    keys,
    matches,
    matchesProperty,
    pickBy,
    union,
    values
} from 'lodash';
import { store } from 'store/store';
import Vue from 'vue';
import VueKonva from 'vue-konva';
import lineClamp from 'vue-line-clamp';
import Vuetify from 'vuetify';
import { mapGetters, mapMutations } from 'vuex';

const _ = {
    findIndex,
    find,
    keys,
    pickBy,
    concat,
    values,
    union,
    filter,
    matches,
    matchesProperty,
    findKey
};

const browser = bowser.getParser(window.navigator.userAgent);

Vue.use(lineClamp, {
    // plugin options
});

Vue.use(VueKonva);
Vue.use(Vuetify);

// eslint-disable-next-line func-names, unicorn/prevent-abbreviations
Vue.config.warnHandler = function(msg, vm, trace) {
    if (
        !msg.includes('The .native modifier for v-on') &
        !msg.includes('Duplicate keys detected') &
        !msg.includes('sidebar') &
        !msg.includes('Failed to mount component: template')
    ) {
        // eslint-disable-next-line no-console
        console.error(msg, trace);
    }
};

Vue.config.devtools = true;

if (module.hot) module.hot.accept();

let developmentServer = true;

/**
 *@returns {boolean} true if location is dev false if not
 */
function checkLocation() {
    const locals = ['127.0.0.1', 'localhost', '192.168.'];

    // eslint-disable-next-line no-restricted-syntax
    for (const local of locals) {
        // eslint-disable-next-line no-restricted-globals
        if (location.host.includes(local)) return true;
    }
    return false;
}

if (!checkLocation()) {
    developmentServer = false;
    Sentry.init({
        Vue,
        dsn: window.VUE_SENTRY_DSN,
        logErrors: true,
        release: window.RELEASE_VERSION,
        environment: window.ENVIRONMENT,
        tracingOptions: {
            trackComponents: true
        }
    });
    Sentry.setUser({ email: window.USER });

    (() => {
        const w = window;
        const ic = w.Intercom;
        if (typeof ic === 'function') {
            ic('reattach_activator');
            ic('update', w.intercomSettings);
        } else {
            const d = document;
            const index = x => {
                index.c(x);
            };
            index.q = [];
            index.c = x => {
                index.q.push(x);
            };
            w.Intercom = index;
            const l = () => {
                const s = d.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = 'https://widget.intercom.io/widget/aftiso2m';
                const x = d.querySelectorAll('script')[0];
                x.parentNode.insertBefore(s, x);
            };
            if (w.attachEvent) {
                w.attachEvent('onload', l);
            } else {
                w.addEventListener('load', l, false);
            }
        }
    })();
}

export default {
    el: '#MainApp',
    delimiters: ['[[', ']]'],
    vuetify,
    store,
    mixins: [viewsInfoMixin, assetSelectorMixin],
    components: {
        reports,
        exports,
        DownloadsDialog
    },
    data() {
        return {
            noDatasetVersionsModal: false,
            supportedBrowserDialog: false,
            platformString: 'none',
            platformType: '',
            drawer: false,
            timeout: null,

            // sites menu data
            sites: [],
            dataset_groups_data: [],
            sites_loading: false,
            sites_search: null,
            sites_select: null,
            sites_dict: {},
            initial_site_load_status: false,
            view_key: 0,
            dataset_groups_loading: false,
            dataset_groups_search: null,
            dataset_groups_select: null,
            dataset_groups_dict: {},
            views_select: null,
            views_select_loading: false,
            datepicker_menu: false,
            datepicker_date: null,
            datasets_list: [],
            dataset_time_selected: null,
            datetime_select: null,

            synced_views: false,
            reportsDialog: false,
            showExportDialog: false,
            showDownloadsDialog: false,
            goToNewView: true,
            onViewPage: false,

            intercomMessengerOpen: false
        };
    },
    methods: {
        ...mapMutations('smartview', [
            'reverseViewsOrder',
            'setSyncedViews',
            'exportCSV',
            'setViewIsFavourite'
        ]),
        ...mapMutations(['setDarkTheme']),
        toggleIntercomMessenger() {
            this.intercomMessengerOpen = !this.intercomMessengerOpen;
        },
        showNewIntercomMessage(message) {
            if (!developmentServer) window.Intercom('showNewMessage', message);
        },
        showOnPage(allowedPages) {
            const currentPage = window.location.pathname;
            // eslint-disable-next-line no-restricted-syntax
            for (const page in allowedPages) {
                if (Object.prototype.hasOwnProperty.call(allowedPages, page)) {
                    if (
                        allowedPages[page][0] === '!' &&
                        currentPage.includes(allowedPages[page].slice(1))
                    ) {
                        return false;
                    }
                    if (
                        allowedPages[page][0] !== '!' &&
                        !currentPage.includes(allowedPages[page])
                    ) {
                        return false;
                    }
                }
            }
            return true;
        },
        nth(n) {
            return (
                ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th'
            );
        },
        closeViewsSelect() {
            try {
                this.$refs.view_select.isMenuActive = false; // open the views menu
                this.$refs.view_select.isFocused = false; //  make the menu selected
            } catch (error) {
                // console.log("isMenuActive and isFocused not loaded/available yet: ", err.message);
            }
        },
        async handleDatasetPackage({
            datasetPackage,
            viewUUID,
            siteSelectorValue
        }) {
            // console.log(typeof datasetPackage.site_uuid);
            // console.log(datasetPackage);
            if (datasetPackage && datasetPackage.site_uuid) {
                if (this.initial_site_load_status) {
                    // fills the sites menu in with the information provided by the dataset package of the view provided

                    if (!siteSelectorValue) {
                        siteSelectorValue = datasetPackage.site_uuid;
                    }
                    this.sites_select = siteSelectorValue;
                    await this.$nextTick();

                    this.dataset_groups_select = datasetPackage
                        ? datasetPackage.dataset_group_uuid
                        : null;
                    await this.$nextTick();

                    this.datetime_select = _.find(this.dataset_datetimes, {
                        time: datasetPackage.time,
                        date: datasetPackage.date
                    });
                    await this.$nextTick();

                    this.goToNewView = false;
                    await this.$nextTick();

                    this.views_select = _.find(this.views, {
                        uuid: viewUUID
                    });

                    await this.$nextTick();
                    this.closeViewsSelect();
                    this.goToNewView = true;
                }
            }
        },
        unloadPage() {
            return 'You have unsaved changes on this page. Are you sure you want to leave?';
        },
        // sites menu methods
        datepicker_selected() {
            try {
                this.views_select = null;
                // wait a tick for the dataset times to be processed
                this.$nextTick(() => {
                    if (this.dataset_times.length === 1) {
                        this.$refs.view_select.isMenuActive = true; // open the views menu
                        this.$refs.view_select.isFocused = true; //  make the menu selected
                        this.datepicker_menu = false; // close the date picker
                    }
                });
            } catch (error) {
                // console.log("isMenuActive and isFocused not loaded/available yet: ", err.message);
            }
        },
        time_selected() {
            try {
                this.datepicker_menu = false; // close the date picker
                this.$refs.view_select.isMenuActive = true; // open the views menu
                this.$refs.view_select.isFocused = true; //  make the menu selected
                this.views_select = null; // clear the views menu selection
            } catch (error) {
                // console.log("isMenuActive and isFocused not loaded/available yet: ", err.message);
            }
        },
        changeViewMain(view) {
            // console.log('selected site :', this.sites_select);
            if (this.sites_select == 'all_sites') {
                let dataset_group = this.dataset_groups.find(
                    dataset_group =>
                        dataset_group.uuid === this.dataset_groups_select
                );
                let site_uuid = dataset_group.site_uuid;
                window.location.href = `/view?view=${view.uuid}&site=${site_uuid}`;
            } else {
                window.location.href = `/view?view=${view.uuid}&site=${this.sites_select}`;
            }
        },
        getSites({
            uuid = null,
            name = null,
            pageSize = null,
            initial_load = false
        } = {}) {
            this.sites_loading = true;
            httpClient
                .get(
                    name === null && uuid === null && pageSize === null
                        ? `/api/v1/sites/?size=${pageSize}`
                        : uuid === null
                        ? `/api/v1/sites/?name=${name}`
                        : `/api/v1/sites/?uuid=${uuid}`
                )
                .then(response => {
                    // var totalCount = response.data['count'];
                    // var next = response.data['next'];
                    // var previous = response.data['previous'];
                    var results = response.data['results'];
                    this.sites = [
                        { name: 'All Locations', uuid: 'all_sites' },
                        ...results
                    ]; // or [{'ss'}].concat(results);
                    // console.log(this.sites);
                    this.sites_loading = false;
                    this.dataset_groups_loading = false;
                    this.sites_dict = this.converSitetArrToDic(results);
                    // set initial_site_load_status true if it's still false
                    if (initial_load) {
                        if (!this.initial_site_load_status) {
                            this.initial_site_load_status = true;
                        }
                    }
                })
                .catch(error => {
                    throw error;
                });
        },
        getDatasetGroups({ uuid = null, name = null, pageSize = null } = {}) {
            this.dataset_groups_loading = true;
            httpClient
                .get(
                    name === null && uuid === null && pageSize === null
                        ? `/api/v1/datasetgroups/?size=${pageSize}`
                        : uuid === null
                        ? `/api/v1/datasetgroups/?name=${name}`
                        : `/api/v1/datasetgroups/?uuid=${uuid}`
                )
                .then(response => {
                    // eslint-disable-next-line no-restricted-syntax
                    // var totalCount = response.data['count'];
                    // var next = response.data['next'];
                    // var previous = response.data['previous'];
                    var results = response.data['results'];
                    this.dataset_groups_loading = false;
                    this.dataset_groups_data = results;
                    // this.sites_dict = this.converSitetArrToDic(results);
                    // console.log(this.sites_dict);
                })
                .catch(error => {
                    throw error;
                });
        },
        validWordID(wordID) {
            return wordID.match(/^(?:[A-Za-z]+-){2}[A-Za-z]+$/) !== null;
        },
        toggleSelectedViewFavourite() {
            if (this.isFavourite) {
                this.removeFromFavourites(this.selectedViewDetails);
            } else {
                this.addToFavourites(this.selectedViewDetails);
            }
        },
        deleteAsset() {
            // console.log('view: ', this.selectedViewDetails);
            // console.log('view type: ', this.selectedViewDetails.component);

            if (
                confirm(
                    'Are you sure you want to delete this view? \n if you do, it cannot be retrieved again'
                )
            ) {
                httpClient
                    .post('/api/delete_view/', {
                        viewUuid: this.selectedViewDetails.viewUUID,
                        viewType: this.selectedViewDetails.component
                    })
                    .then(response => {
                        if (response.data.success) {
                            // redirect to home page from the UI
                            window.location.replace('/');
                        }

                        if (!response.data.success) {
                            // Display message
                            window.alert(response.data.message);
                        }
                    })
                    .catch(error => {
                        throw error;
                    });
            } else {
                return true;
            }
        },
        addToFavourites(view) {
            httpClient
                .post('/api/add_favourite_view/', {
                    viewUuid: view.viewUUID
                })
                .then(response => {
                    if (response.data.success) {
                        this.setViewIsFavourite([this.selectedView, true]);
                    }
                })
                .catch(error => {
                    throw error;
                });
            trackDashboardEvents.favouriteAdded(
                this.viewsOnPage[this.selectedView]
            );
        },
        removeFromFavourites(view) {
            httpClient
                .post('/api/remove_favourite_view/', {
                    viewUuid: view.viewUUID
                })
                .then(response => {
                    if (response.data.success) {
                        this.setViewIsFavourite([this.selectedView, false]);
                    }
                })
                .catch(error => {
                    throw error;
                });
            trackDashboardEvents.favouriteRemoved(
                this.viewsOnPage[this.selectedView]
            );
        },
        converSitetArrToDic(site_array) {
            /**
             * This method convert site json array from API and convert it to Dictionary
             * used by the app for quick data lookup
             * @author: Williams Francis <w.francis@nationaldrones.com> | <olawalewilliams9438@gmail.com>
             */
            var data_dict = {};

            site_array.forEach(site => {
                var sites_dic = { [site.uuid]: site };

                var dataset_groups = sites_dic[site.uuid].dataset_groups;
                // Test dataset_group is null or undefined return else proceed
                if (dataset_groups === null || dataset_groups === 'undefined')
                    return;

                var dataset_group_dics = {};
                dataset_groups.forEach(dataset_group => {
                    var dataset_group_dic = {
                        [dataset_group.uuid]: dataset_group
                    };
                    Object.assign(dataset_group_dics, dataset_group_dic);

                    sites_dic[site.uuid].dataset_groups = dataset_group_dics;

                    var datasets = dataset_group.datasets;
                    // Test dataset_group is null or undefined return else proceed
                    if (
                        dataset_groups === null ||
                        dataset_groups === 'undefined'
                    )
                        return;

                    var dataset_dics = {};
                    datasets.forEach(dataset => {
                        var dataset_dic = { [dataset.uuid]: dataset };
                        Object.assign(dataset_dics, dataset_dic);

                        sites_dic[site.uuid].dataset_groups[
                            dataset_group.uuid
                        ].datasets = dataset_dics;
                    });
                });

                Object.assign(data_dict, sites_dic);
            });
            // console.log(data_dict);

            return data_dict;
        }
    },
    created() {
        /**
         * This is where the mainMixing initial data needed for the page is loaded
         * and the site or all_sites get parameter is also gotten from if available to be used on the page.
         * @author: Williams Francis <w.francis@nationaldrones.com> | <olawalewilliams9438@gmail.com>
         *
         */
        const queryString = window.location.search;
        const urlParameters = new URLSearchParams(queryString);
        if (urlParameters.has('site')) {
            const site_uuid = urlParameters.get('site');
            // console.log(site_uuid);
            this.getSites({ uuid: site_uuid, initial_load: true });
        } else {
            this.getSites();
            this.getDatasetGroups();
        }
    },
    computed: {
        ...mapGetters(['darkTheme']),
        ...mapGetters('smartview', [
            'getIdCounter',
            'viewsOnPage',
            'selectedView',
            'setSyncedViews',
            'selectedViewDetails',
            'selectedViewIsFavourite'
        ]),
        isFavourite() {
            return this.selectedViewIsFavourite;
        },
        reportsEnabled() {
            return this.viewsOnPage && this.viewsOnPage[this.selectedView]
                ? this.viewsOnPage[this.selectedView].enableReports
                : false;
        },
        toolbar_buttons() {
            // a list of the buttons in the right side of the app bar, will automatically move into a menu when the window shrinks
            return [
                {
                    icon: '$vuetify.icons.upload',
                    text: 'Upload Asset',
                    align: 'left',
                    enabled: true,
                    action: false,
                    link: '/upload',
                    type: 'text',
                    showOnPage:
                        this.showOnPage([
                            '!/view',
                            '!/upload',
                            '!/accounts/plan/select'
                        ]) && !window.errorPage
                },
                {
                    icon: this.synced_views
                        ? '$vuetify.icons.unSync'
                        : '$vuetify.icons.sync',
                    text: this.synced_views
                        ? 'Stop Syncing Views'
                        : 'Sync Views',
                    align: 'left',
                    enabled: this.viewsOnPage.length > 1,
                    action: () => {
                        if (!this.synced_views) {
                            trackDashboardEvents.syncViewUsed(this.viewsOnPage);
                        }
                        this.synced_views = !this.synced_views;
                    },
                    link: null,
                    type: 'icon',
                    showOnPage: this.showOnPage(['/view'])
                },
                {
                    icon: '$vuetify.icons.close',
                    text: `Close ${this.selectedView +
                        1 +
                        this.nth(this.selectedView + 1)} View`,
                    align: 'left',
                    enabled: this.viewsOnPage.length > 1,
                    action: () => {
                        this.removeView(this.selectedView);
                    },
                    link: null,
                    type: 'icon',
                    showOnPage: this.showOnPage(['/view'])
                },
                {
                    icon: '$vuetify.icons.expandView',
                    text: `Expand ${this.selectedView +
                        1 +
                        this.nth(this.selectedView + 1)} View`,
                    align: 'left',
                    enabled: this.viewsOnPage.length > 1,
                    action: () => {
                        this.replaceViews(this.selectedViewDetails);
                    },
                    link: null,
                    type: 'icon',
                    showOnPage: this.showOnPage(['/view'])
                },
                {
                    icon: '$vuetify.icons.swapViews',
                    text: `Swap Views`,
                    align: 'left',
                    enabled: this.viewsOnPage.length > 1,
                    action: () => {
                        this.reverseViewsOrder();
                    },
                    link: null,
                    type: 'icon',
                    showOnPage: this.showOnPage(['/view'])
                },
                {
                    icon: '$vuetify.icons.report',
                    text: `Reports for ${this.selectedView +
                        1 +
                        this.nth(this.selectedView + 1)} View`,
                    align: 'left',
                    enabled: this.reportsEnabled,
                    action: () => {
                        this.reportsDialog = true;
                    },
                    link: null,
                    type: 'icon',
                    showOnPage: this.showOnPage(['/view'])
                },
                {
                    icon: this.isFavourite
                        ? '$vuetify.icons.solidStar'
                        : '$vuetify.icons.hollowStar',
                    text: this.isFavourite
                        ? 'Remove from favourites.'
                        : 'Add to favourites',
                    align: 'left',
                    enabled: true,
                    action: () => {
                        this.toggleSelectedViewFavourite();
                    },
                    link: null,
                    type: 'icon',
                    showOnPage: this.showOnPage(['/view'])
                },
                {
                    icon: '$vuetify.icons.fileExportReg',
                    text: 'Export files',
                    align: 'left',
                    enabled: this.reportsEnabled,
                    action: () => {
                        this.showExportDialog = true;
                    },
                    type: 'icon',
                    showOnPage: this.showOnPage(['/view'])
                },
                {
                    icon: '$vuetify.icons.outlineDownload',
                    text: 'Download Asset',
                    align: 'left',
                    enabled: true,
                    action: () => {
                        this.showDownloadsDialog = true;
                    },
                    type: 'icon',
                    showOnPage: this.showOnPage(['/view'])
                },
                {
                    icon: '$vuetify.icons.delete',
                    text: 'Delete Asset',
                    align: 'left',
                    enabled: true,
                    action: () => {
                        this.deleteAsset();
                    },
                    type: 'icon',
                    showOnPage: this.showOnPage(['/view'])
                },
                {
                    icon: '$vuetify.icons.settingsOutline',
                    text: 'Manage Asset',
                    align: 'left',
                    enabled: true,
                    action: () => {
                        const siteUuid = this.selectedViewDetails.datasetPackage
                            .site_uuid;
                        const datasetGroupUuid = this.selectedViewDetails
                            .datasetPackage.dataset_group_uuid;
                        window.location = `/locations/${siteUuid}/${datasetGroupUuid}`;
                    },
                    type: 'icon',
                    showOnPage:
                        this.showOnPage(['/view']) &&
                        this.manageAssetButtonEnabled
                }
            ];
        },
        numberOfToolbarButtons() {
            return _.keys(
                _.pickBy(this.toolbar_buttons, o => {
                    return o.showOnPage;
                })
            ).length;
        },
        // sites menu computed
        // eslint-disable-next-line sonarjs/cognitive-complexity
        dataset_groups() {
            let array = [];
            if (this.sites_select === 'all_sites') {
                // if 'all sites' is selected get all of the datasets from datasetgroup API (/api/v1/datasetgroups/)
                // eslint-disable-next-line no-restricted-syntax
                array = this.dataset_groups_data;
            } else if (this.sites.length > 0 && this.sites_select !== null) {
                try {
                    // if there are sites and a site is selected get its datasets
                    const dict = this.sites_dict[this.sites_select]
                        .dataset_groups;
                    array = _.values(dict);
                } catch (e) {
                    // This is a temp fix for veiws link without site param
                    const queryString = window.location.search;
                    const urlParameters = new URLSearchParams(queryString);
                    if (!urlParameters.has('site')) {
                        //if no site param use dummy
                        const dict = this.sites_dict[this.sites[3].uuid]
                            .dataset_groups;
                        array = _.values(dict);
                    } else {
                        array = [];
                    }
                }
            }

            const viewTypes = Object.keys(this.view_options);

            array.forEach(dsGroup => {
                if (dsGroup.datasets) {
                    return;
                }

                dsGroup.datasets.forEach(ds => {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const viewType in viewTypes) {
                        if (ds[`${viewType}_published`]) {
                            break;
                        }
                    }
                });
            });

            return array;
        },
        views() {
            // returns a list of unique views for the views select
            let views = [];

            if (!this.datetime_select) return [];

            // Find the dataset object that matches the time and date selected
            const dataset = this.datasets_list[
                _.findKey(this.datasets_list, o => {
                    return (
                        o.time === this.datetime_select.time &&
                        o.date === this.datetime_select.date
                    );
                })
            ];

            if (!dataset) return [];

            // eslint-disable-next-line no-restricted-syntax
            for (const view in this.view_options) {
                if (
                    dataset[view] &&
                    dataset[`${this.view_options[view].type}_published`]
                ) {
                    const listItem = this.view_options[view];
                    listItem.uuid = dataset[view];
                    listItem.notPublished = !dataset[
                        `${this.view_options[view].type}_published`
                    ];

                    /**
                     * had to change this to concat because _union return empty and
                     * i beleive bcos it couldn't compare object to return unique list and soetimes
                     * it does (inconsistent and yet to find the reason).
                     * Note: For now concat does the job better and no need for unique list as the list return is always unique
                     * @author: Williams Francis <w.francis@nationaldrones.com> | <olawalewilliams9438@gmail.com>
                     *
                     */
                    views = views.concat([listItem]);
                    // views = _.union(views, [listItem]);
                    // console.log("Views: " + views);
                }
            }

            return views;
        },
        // eslint-disable-next-line sonarjs/cognitive-complexity
        dataset_datetimes() {
            const months = {
                '01': 'Jan',
                '02': 'February',
                '03': 'Mar',
                '04': 'Apr',
                '05': 'May',
                '06': 'Jun',
                '07': 'Jul',
                '08': 'Aug',
                '09': 'Sep',
                '10': 'Oct',
                '11': 'Nov',
                '12': 'Dec'
            };

            const datesExistingSet = new Set();

            // get a list of the dates and times of the datasets that have the view type that is currently selected
            const array = [];
            // eslint-disable-next-line guard-for-in,no-restricted-syntax
            for (const dataset in this.datasets_list) {
                let hasPublishedViews = false;
                // eslint-disable-next-line no-restricted-syntax
                for (const viewType in this.view_options) {
                    if (this.datasets_list[dataset][`${viewType}_published`]) {
                        hasPublishedViews = true;
                        break;
                    }
                }
                if (!hasPublishedViews) {
                    // eslint-disable-next-line no-continue
                    continue;
                }

                if (!datesExistingSet.has(this.datasets_list[dataset].date)) {
                    datesExistingSet.add(this.datasets_list[dataset].date);
                } else {
                    datesExistingSet.delete(this.datasets_list[dataset].date);
                }

                array.push({
                    date: this.datasets_list[dataset].date,
                    time: this.datasets_list[dataset].time
                });
            }

            array.forEach(element => {
                const dateArray = element.date.split('-');
                if (datesExistingSet.has(element.date)) {
                    element.display = `${dateArray[2]} ${
                        months[dateArray[1]]
                    } ${dateArray[0]}`;
                } else {
                    element.display = `${element.time} ${dateArray[2]} ${
                        months[dateArray[1]]
                    } ${dateArray[0]}`;
                }
            });

            array.sort((a, b) => {
                const dateA = new Date(`${a.date.replace('-', ' ')} ${a.time}`);
                const dateB = new Date(`${b.date.replace('-', ' ')} ${b.time}`);
                return dateA.getTime() > dateB.getTime() ? -1 : 1;
            });
            return array;
        },
        showSiteSelect() {
            return (
                !window.errorPage &&
                // eslint-disable-next-line no-restricted-globals
                location.pathname !== '/accounts/plan/select'
            );
        },

        // base template computed
        logoUrl() {
            return '/static/img/logos/Smartdata_square_L.png';
        },
        bigLogoUrl() {
            if (this.darkTheme) {
                return '/static/img/logos/Smartdata_light_L.png';
            }
            return '/static/img/logos/Smartdata_dark_L.png';
        },
        isOSDarkMode() {
            return window.matchMedia('(prefers-color-scheme: dark)').matches;
        },
        supportedBrowser() {
            return browser.satisfies({
                chrome: '>65',
                firefox: '>60',
                safari: '>10',
                edge: '>10'
            });
        },
        isTouchScreen() {
            return 'ontouchstart' in document.documentElement;
        },
        manageAssetButtonEnabled() {
            if (
                !this.selectedViewDetails ||
                !this.selectedViewDetails.datasetPackage
            ) {
                return false;
            }
            return this.selectedViewDetails.datasetPackage.userCanEditSite;
        },

        // protected variables
        siteDataDict() {
            // console.log(userSitesDict);
            // eslint-disable-next-line no-undef
            return typeof userSitesDict !== 'undefined' ? userSitesDict : {}; // pulling from window variable set in base.html template
        },
        // eslint-disable-next-line unicorn/prevent-abbreviations
        siteDataArr() {
            // console.log(userSitesArray)
            // eslint-disable-next-line no-undef
            return typeof userSitesArray !== 'undefined' ? userSitesArray : []; // pulling from window variable set in base.html template
        },
        googleMapsKey() {
            // TODO move these keys to env variables
            // Putting this here means it can't be accidentally overwritten.
            return 'AIzaSyDnHuPX4n7Sw0v5-9VovHupbhCLsIBC0Dg';
        }
    },
    watch: {
        initial_site_load_status() {
            if (this.initial_site_load_status) {
                this.handleDatasetPackage(this.viewsOnPage[this.selectedView]);
            }
        },
        intercomMessengerOpen(value) {
            if (!developmentServer) {
                if (value) {
                    window.Intercom('show');
                } else {
                    window.Intercom('hide');
                }
            }
        },
        reportsDialog(value) {
            const url = new Url();
            if (value) {
                url.query.reports = true;
            } else {
                delete url.query.reports;
            }
            // eslint-disable-next-line no-restricted-globals
            history.pushState(null, null, url);
        },
        synced_views(value) {
            const url = new Url();
            this.setSyncedViews(this.synced_views);

            if (value) {
                url.query.sync = true;
            } else {
                delete url.query.sync;
            }
            // eslint-disable-next-line no-restricted-globals
            history.pushState(null, null, url);
        },
        views_select(value) {
            if (this.goToNewView) {
                this.changeViewMain({ uuid: value });
            }
        },
        // sites menu watch
        sites_select() {
            /**
             * @param node
             * @param eventType
             */
            // eslint-disable-next-line unicorn/consistent-function-scoping
            function triggerMouseEvent(node, eventType) {
                /* 
                    Deprecated: This feature (clickEvent.initEvent) is no longer recommended and deprecated.
                    @author: Williams Francis <w.francis@nationaldrones.com> | <olawalewilliams9438@gmail.com>
                */
                // const clickEvent = document.createEvent('MouseEvents');
                // clickEvent.initEvent(eventType, true, true);
                // node.dispatchEvent(clickEvent);

                var event_ = new Event(eventType, {
                    bubbles: true,
                    cancelable: false
                });
                // document.dispatchEvent(evt);
                node.dispatchEvent(event_);
            }
            // wait for dataset groups to be computed
            this.$nextTick(() => {
                if (this.dataset_groups.length === 1) {
                    // if there is only one dataset group the automatically select it
                    this.$nextTick(() => {
                        // noinspection JSPotentiallyInvalidTargetOfIndexedPropertyAccess
                        this.dataset_groups_select = this.dataset_groups[0].uuid;
                    });
                } else if (this.dataset_groups.length > 1) {
                    try {
                        // pop the dataset menu open (this shouldn't be this complex)
                        this.$refs.dataset_autocomplete.focus();

                        this.$nextTick(() => {
                            this.$refs.dataset_autocomplete.isMenuActive = true;
                            this.$refs.site_autocomplete.isFocused = false;

                            // Simulate a mousedown event on the first element of the dropdown
                            // This fixes issue ND-168 and causes the menu to update the dimensions
                            // according to the length of the text in the menu properly
                            this.$nextTick(() => {
                                try {
                                    const node = this.$refs.dataset_autocomplete
                                        .$refs.menu.$refs.content
                                        .firstElementChild.firstElementChild;

                                    triggerMouseEvent(node, 'mousedown');
                                } catch (error) {
                                    // console.log("firstElementChild not loaded/available yet: ", err.message);
                                }
                            });
                        });
                    } catch (error) {
                        // console.log("firstElementChild, isMenuActive and isFocused not loaded/available yet: ", err.message);
                    }
                }
            });
        },
        // eslint-disable-next-line no-unused-vars
        sites_search(value) {
            let input = document.getElementById('sites_search');

            // Listen for keystroke events
            input.addEventListener('keyup', e => {
                // Clear the timeout if it has already been set.
                // This will prevent the previous task from executing
                clearTimeout(this.timeout);

                // Make a new timeout set to go off in 1000ms (1 second)
                this.timeout = setTimeout(() => {
                    // console.log('Input Value:', input.value);

                    // Items have already been requested
                    if (this.sites_loading) return;

                    this.getSites({ name: input.value });
                }, 1000);
            });
        },
        dataset_groups_select(value) {
            let data;

            // eslint-disable-next-line no-restricted-syntax
            for (const dataset in this.dataset_groups) {
                if (
                    Object.prototype.hasOwnProperty.call(
                        this.dataset_groups,
                        dataset
                    ) &&
                    this.dataset_groups[dataset].uuid ===
                        this.dataset_groups_select
                ) {
                    data = this.dataset_groups[dataset].datasets;
                }
            }

            this.datasets_list = data;
            this.datetime_select = null; // reset the date

            this.$nextTick(() => {
                try {
                    if (value) {
                        this.$refs.dataset_autocomplete.isFocused = false;
                        if (this.dataset_datetimes.length === 0) {
                            this.noDatasetVersionsModal = true;
                        } else {
                            // focus the autocomplete and drop down the menu
                            this.$refs.date_autocomplete.isFocused = true;
                            this.$nextTick(() => {
                                this.$refs.date_autocomplete.isMenuActive = true;
                            });
                        }
                    }
                } catch (error) {
                    // console.log("isMenuActive and isFocused not loaded/available yet: ", err.message);
                }
            });
        },
        datetime_select(value) {
            try {
                if (!value) return;

                this.$refs.date_autocomplete.isFocused = false;
                this.$nextTick(() => {
                    this.$refs.view_select.isFocused = true;
                    this.$nextTick(() => {
                        this.$refs.view_select.isMenuActive = true;
                    });
                });
            } catch (error) {
                // console.log("isMenuActive and isFocused not loaded/available yet: ", err.message);
            }
        },
        // eslint-disable-next-line no-unused-vars
        dataset_groups_search(value) {
            let input = document.getElementById('dataset_groups_search');

            // Listen for keystroke events
            input.addEventListener('keyup', e => {
                // Clear the timeout if it has already been set.
                // This will prevent the previous task from executing
                clearTimeout(this.timeout);

                // Make a new timeout set to go off in 1000ms (1 second)
                this.timeout = setTimeout(() => {
                    // console.log('Input Value:', input.value);

                    // Items have already been requested
                    if (this.dataset_groups_loading) return;

                    this.getDatasetGroups({ name: input.value });
                }, 1000);
            });
        },
        // other watch
        darkTheme() {
            this.$vuetify.theme.dark = this.darkTheme;
            localStorage.darkTheme = this.darkTheme;

            const style = document.createElement('style');
            const styleDiv = document.querySelector('#styleDiv');

            if (this.darkTheme) {
                styleDiv.append(style);
                style.append(
                    document.createTextNode(
                        'input:-webkit-autofill,\n' +
                            'input:-webkit-autofill:hover,\n' +
                            'input:-webkit-autofill:focus,\n' +
                            'textarea:-webkit-autofill,\n' +
                            'textarea:-webkit-autofill:hover,\n' +
                            'textarea:-webkit-autofill:focus,\n' +
                            'select:-webkit-autofill,\n' +
                            'select:-webkit-autofill:hover,\n' +
                            'select:-webkit-autofill:focus {\n' +
                            '    -webkit-text-fill-color: #fff!important;\n' +
                            '}'
                    )
                );
                style.append(
                    document.createTextNode(
                        'div.v-dialog__container > div > div > div > div.v-card__actions > button.v-btn.v-btn--contained.theme--light.v-size--default.primary > span, .v-card.v-sheet.v-sheet--tile, .v-card__text, .v-btn.v-btn--contained.theme--light.v-size--default, .leaflet-popup-content-wrapper, .leaflet-popup-tip, .leaflet-control-zoom-in, .leaflet-control-zoom-out, #toggle-mode-btn, #dataset-view-button, .leaflet-bar a {\n' +
                            '    background-color: #1E1E1E!important;\n' +
                            '    color: #FFFFFF!important;\n' +
                            '}'
                    )
                );
                style.append(
                    document.createTextNode(
                        '.leaflet-touch .leaflet-control-layers, .leaflet-touch .leaflet-bar {\n' +
                            '    border-color: #666666 !important;\n' +
                            '}'
                    )
                );
                style.append(
                    document.createTextNode(
                        '.leaflet-draw-toolbar a {\n' +
                            "    background-image: url(\"data:image/svg+xml,%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' height='60' width='600' version='1.1' inkscape:version='0.91 r13725' sodipodi:docname='spritesheet.svg' inkscape:export-filename='/home/fpuga/development/upstream/icarto.Leaflet.draw/src/images/spritesheet-2x.png' inkscape:export-xdpi='90' inkscape:export-ydpi='90' style=''%3E%3Crect id='backgroundrect' width='100%25' height='100%25' x='0' y='0' fill='none' stroke='none'/%3E%3Cmetadata id='metadata4258'%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=''%3E%3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E%3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage'/%3E%3Cdc:title/%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cdefs id='defs4256'/%3E%3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='1920' inkscape:window-height='1056' id='namedview4254' showgrid='false' inkscape:zoom='1.3101852' inkscape:cx='237.56928' inkscape:cy='7.2419621' inkscape:window-x='1920' inkscape:window-y='24' inkscape:window-maximized='1' inkscape:current-layer='svg4225'/%3E%3Cg class='currentLayer' style=''%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cg id='enabled' style='' class='' fill='%23ffffff' fill-opacity='1'%3E%3Cg id='polyline' style='' fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='m 18,36 0,6 6,0 0,-6 -6,0 z m 4,4 -2,0 0,-2 2,0 0,2 z' id='path4229' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3Cpath d='m 36,18 0,6 6,0 0,-6 -6,0 z m 4,4 -2,0 0,-2 2,0 0,2 z' id='path4231' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3Cpath d='m 23.142,39.145 -2.285,-2.29 16,-15.998 2.285,2.285 z' id='path4233' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3C/g%3E%3Cpath id='polygon' d='M 100,24.565 97.904,39.395 83.07,42 76,28.773 86.463,18 Z' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3Cpath id='rectangle' d='m 140,20 20,0 0,20 -20,0 z' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3Cpath id='circle' d='m 221,30 c 0,6.078 -4.926,11 -11,11 -6.074,0 -11,-4.922 -11,-11 0,-6.074 4.926,-11 11,-11 6.074,0 11,4.926 11,11 z' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3Cpath id='marker' d='m 270,19 c -4.971,0 -9,4.029 -9,9 0,4.971 5.001,12 9,14 4.001,-2 9,-9.029 9,-14 0,-4.971 -4.029,-9 -9,-9 z m 0,12.5 c -2.484,0 -4.5,-2.014 -4.5,-4.5 0,-2.484 2.016,-4.5 4.5,-4.5 2.485,0 4.5,2.016 4.5,4.5 0,2.486 -2.015,4.5 -4.5,4.5 z' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3Cg id='edit' style='' fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='m 337,30.156 0,0.407 0,5.604 c 0,1.658 -1.344,3 -3,3 l -10,0 c -1.655,0 -3,-1.342 -3,-3 l 0,-10 c 0,-1.657 1.345,-3 3,-3 l 6.345,0 3.19,-3.17 -9.535,0 c -3.313,0 -6,2.687 -6,6 l 0,10 c 0,3.313 2.687,6 6,6 l 10,0 c 3.314,0 6,-2.687 6,-6 l 0,-8.809 -3,2.968' id='path4240' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3Cpath d='m 338.72,24.637 -8.892,8.892 -2.828,0 0,-2.829 8.89,-8.89 z' id='path4242' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3Cpath d='m340.7130818841731,22.643304864723405 l-2.8279335498809814,0 l0,-2.8279335498809814 l2.8279335498809814,0 z' id='path4244' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3C/g%3E%3Cg id='remove' style='' fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='m 381,42 18,0 0,-18 -18,0 0,18 z m 14,-16 2,0 0,14 -2,0 0,-14 z m -4,0 2,0 0,14 -2,0 0,-14 z m -4,0 2,0 0,14 -2,0 0,-14 z m -4,0 2,0 0,14 -2,0 0,-14 z' id='path4247' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3Cpath d='m 395,20 0,-4 -10,0 0,4 -6,0 0,2 22,0 0,-2 -6,0 z m -2,0 -6,0 0,-2 6,0 0,2 z' id='path4249' inkscape:connector-curvature='0' style='' fill='%23ffffff' fill-opacity='1'/%3E%3C/g%3E%3C/g%3E%3Cg id='disabled' style='fill:%23bbbbbb'%3E%3Cuse xlink:href='%23edit' id='edit-disabled' x='120' y='0' width='100%25' height='100%25'/%3E%3Cuse xlink:href='%23remove' id='remove-disabled' x='120' y='0' width='100%25' height='100%25'/%3E%3C/g%3E%3Cpath style='stroke-width: 2px; stroke-miterlimit: 4; stroke-dasharray: none;' id='circle-3' d='m 581.65725,30 c 0,6.078 -4.926,11 -11,11 -6.074,0 -11,-4.922 -11,-11 0,-6.074 4.926,-11 11,-11 6.074,0 11,4.926 11,11 z' inkscape:connector-curvature='0' class='selected' fill='none' stroke='%23ffffff' stroke-opacity='1'/%3E%3C/g%3E%3C/svg%3E\") !important;\n" +
                            '}'
                    )
                );
                style.append(
                    document.createTextNode(
                        '.leaflet-container:not(.leaflet-control-minimap) {\n' +
                            'background: #303030 !important;\n' +
                            '}'
                    )
                );
                style.append(
                    document.createTextNode(
                        '.handle-bl {\n' +
                            'background-color: #1E1E1E;\n' +
                            "background-image: url('/static/img/expand-alt-white.svg');\n" +
                            '}'
                    )
                );
                style.append(
                    document.createTextNode(
                        '.inspectionImageDownloadButton {\n' +
                            "background-image: url('/static/img/download-white.svg');\n" +
                            '}'
                    )
                );
                style.append(
                    document.createTextNode(
                        '.hideAutoAnnotationsButton {\n' +
                            "background-image: url('/static/img/robot-white.svg');\n" +
                            '}'
                    )
                );
                style.append(
                    document.createTextNode(
                        '.hideAutoAnnotationsButton.hidden:after {\n' +
                            'background: white !important;\n' +
                            '}'
                    )
                );
            } else {
                styleDiv.innerHTML = '';
            }
        }
    },
    // eslint-disable-next-line sonarjs/cognitive-complexity
    mounted() {
        axios.defaults.xsrfCookieName = 'csrftoken';
        axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';

        var mql = window.matchMedia('(prefers-color-scheme: dark)');
        mql.addEventListener('change', event => {
            if (event.matches) this.setDarkTheme(true);
        });
        mql = window.matchMedia('(prefers-color-scheme: light)');
        mql.addEventListener('change', event => {
            if (event.matches) this.setDarkTheme(false);
        });

        if (this.isOSDarkMode) this.setDarkTheme(true);
        if (localStorage.darkTheme === 'true') this.setDarkTheme(true);
        if (localStorage.darkTheme === 'false') this.setDarkTheme(false);

        if (this.isTouchScreen) {
            delete Hammer.defaults.cssProps.userSelect;
            const hammertime = new Hammer(document.querySelector('#MainApp'));
            const $this = this;

            hammertime.on('swiperight', () => {
                $this.drawer = true;
            });

            hammertime.on('swipeleft', () => {
                $this.drawer = false;
            });
        }

        this.platformString = `${browser.getBrowserName()} ${browser.getBrowserVersion()} on ${browser.getOSName()} ${browser.getOSVersion()}`;
        this.platformType = browser.getPlatformType();

        if (!this.supportedBrowser) {
            if (
                window.location.pathname !== '/support/' &&
                window.location.pathname !== '/tools/compatibility/'
            ) {
                this.supportedBrowserDialog = true;
            } else {
                // eslint-disable-next-line no-alert
                window.alert(
                    'Your browser is not supported. Please upgrade to a supported browser.'
                );
            }
        }

        const sites = [{ name: 'All Locations', uuid: 'all_sites' }];
        this.sites = sites;
        this.sites_dict = this.siteDataDict;

        const url = new Url();
        if (url.query.reports) {
            this.reportsDialog = true;
        }

        if (url.query.sync) {
            this.synced_views = true;
        }

        if (!developmentServer) {
            window.Intercom('onShow', () => {
                this.intercomMessengerOpen = true;
            });

            window.Intercom('onHide', () => {
                this.intercomMessengerOpen = false;
            });
        }
    }
};

window.ndmobilecheck = function ndmobilecheck() {
    browser.satisfies({
        mobile: {
            safari: '>=9',
            'android browser': '>3.10'
        }
    });
};
